export const UNITS = "units"
export const TOTALS = "totals"
export const MARGINS = "margins"
export const REDUCTIONS = "reductions"
export const DIMENSIONS = "dimensions"
export const MEASUREMENTS = "measurements"
export const SUB_DECOMPOSITIONS = "sub_decompositions"
export const TOTAL_DECOMPOSITIONS = "total_decompositions"

export const COEFFICIENT_DECIMALS_CAP = 6

export const DEFAULT_DECIMALS = {
  [UNITS]: 2,
  [TOTALS]: 2,
  [MARGINS]: 2,
  [REDUCTIONS]: 3,
  [DIMENSIONS]: 3,
  [MEASUREMENTS]: 3,
  [SUB_DECOMPOSITIONS]: 3,
  [TOTAL_DECOMPOSITIONS]: 3,
}
